"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowSize = void 0;
const react_1 = require("react");
const state_1 = require("../../../state");
const env_1 = require("../../env");
const useWindowSize = () => {
    const [shoppingPortalState] = (0, state_1.useShoppingPortalStore)();
    const { getDeviceAttributes } = state_1.shoppingPortalSelectors;
    const deviceType = getDeviceAttributes(shoppingPortalState);
    const getSize = () => ({
        height: (0, env_1.isBrowser)() ? window.innerHeight : undefined,
        isMobile: deviceType !== 'DESKTOP' ? true : false,
        width: (0, env_1.isBrowser)() ? window.innerWidth : undefined
    });
    const [windowSize, setWindowSize] = (0, react_1.useState)(getSize());
    (0, react_1.useEffect)(() => {
        if (!(0, env_1.isBrowser)()) {
            return;
        }
        const handleResize = () => {
            setWindowSize(getSize());
        };
        window.addEventListener('resize', handleResize);
        setWindowSize(getSize());
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return windowSize;
};
exports.useWindowSize = useWindowSize;
